import type { AgentMessagePart } from '../../types/agent-messages';
import type { ParserContext, ParserResult } from './types';

const FENCED_CODE_RE =
  /```(sql|pyspark|python)\s*\n([\s\S]*?)```/gi;

/**
 * Extracts fenced code blocks (```sql, ```pyspark, ```python) from markdown
 * text and produces `codeBlock` parts. Interleaves `text` parts for prose
 * between code blocks so message ordering is preserved.
 */
export function codeBlockParser(ctx: ParserContext): ParserResult {
  const parts: AgentMessagePart[] = [];
  let remaining = ctx.text;
  let lastIndex = 0;
  const segments: Array<{ type: 'text' | 'code'; value: AgentMessagePart }> = [];

  let match: RegExpExecArray | null;
  const re = new RegExp(FENCED_CODE_RE.source, FENCED_CODE_RE.flags);

  while ((match = re.exec(ctx.text)) !== null) {
    const before = ctx.text.slice(lastIndex, match.index).trim();
    if (before) {
      segments.push({ type: 'text', value: { type: 'text', content: before } });
    }

    segments.push({
      type: 'code',
      value: {
        type: 'codeBlock',
        language: match[1].toLowerCase(),
        code: match[2].trimEnd(),
      },
    });

    lastIndex = match.index + match[0].length;
  }

  if (segments.length === 0) {
    return { parts: [], remainingText: ctx.text };
  }

  const after = ctx.text.slice(lastIndex).trim();

  for (const seg of segments) {
    parts.push(seg.value);
  }

  return { parts, remainingText: after };
}
